
import React from 'react';
import { User, Settings, ChevronRight } from 'lucide-react';

interface ProfileSubmenuProps {
  profileSubmenuOpen: boolean;
  onToggle: () => void;
  onViewProfile: () => void;
  onEditProfile: () => void;
}

export const ProfileSubmenu: React.FC<ProfileSubmenuProps> = ({
  profileSubmenuOpen,
  onToggle,
  onViewProfile,
  onEditProfile
}) => {
  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-3 px-4 py-2 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
      >
        <div className="flex items-center gap-3">
          <User className="h-4 w-4" />
          Profile
        </div>
        <ChevronRight className={`h-4 w-4 transition-transform ${profileSubmenuOpen ? 'rotate-90' : ''}`} />
      </button>
      
      {profileSubmenuOpen && (
        <div className="ml-4 border-l border-gray-700 pl-4 py-1">
          <button
            onClick={onViewProfile}
            className="w-full flex items-center gap-3 px-4 py-2 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors text-sm"
          >
            <User className="h-3 w-3" />
            View Profile
          </button>
          <button
            onClick={onEditProfile}
            className="w-full flex items-center gap-3 px-4 py-2 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors text-sm"
          >
            <Settings className="h-3 w-3" />
            Edit Profile
          </button>
        </div>
      )}
    </div>
  );
};
